import Backbone from 'backbone';
import Util from 'root/module/util';

export default Backbone.Model.extend({
    defaults: {
        email                   : '',
        display_name            : '',
        is_email_confirmed      : false,
        created_at              : 0,
        last_login              : 0,
        unsubscribe_all         : false,
        avatar                  : ''
    },

    getAvatar: function(size) {
        size = size || 128;

        if (this.get('avatar')) {
            return this.get('avatar');
        } else {
            return Util.gravatar(this.get('email'), size, this.get('display_name'));
        }
    }
});